export default {
	nodes: [
		{
			id: '10',
			name: '初入职场',
		},
		{
			id: '1',
			name: '采矿技术员',
			conf: [],
		},
		{
			id: '2',
			name: '地质工程师助理',
			conf: [],
		},
		{
			id: '3',
			name: '采矿工程师',
			conf: [],
		},
		{
			id: '4',
			name: '生产技术主管',
			conf: [],
		},
		{
			id: '5',
			name: '矿山经理',
			conf: [],
		},
		{
			id: '6',
			name: '采矿总工程师',
			conf: [],
		},
		{
			id: '7',
			name: '采矿资深专家',
			conf: [],
		},
	],
	edges: [
		{
			source: '10',
			target: '1',
		},
		{
			source: '10',
			target: '2',
		},
		{
			source: '1',
			target: '3',
		},
		{
			source: '2',
			target: '3',
		},
		{
			source: '3',
			target: '4',
		},
		{
			source: '4',
			target: '5',
		},
		{
			source: '4',
			target: '6',
		},
		{
			source: '4',
			target: '7',
		}
	],
};